import InfiniteScrollComponent from 'react-infinite-scroll-component'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import LoadingSpinner from '../common/loader/legacy-loaders/LoadingSpinner'
import styles from './InfiniteScroll.module.scss'
import { ReactComponent as FlagIcon } from '../../assets/images/common/icons/Flag.svg'

const InfiniteScroll = ({ loaderClassName, endOfList, children, hideLoader = false, ...props }) => {
  const { t } = useTranslation()

  return (
    <InfiniteScrollComponent
      loader={!hideLoader ? <LoadingSpinner className={loaderClassName} /> : null}
      {...props}
    >
      {children}
      {endOfList &&
        <div className={styles.endOfList}>
          <FlagIcon className={styles.endIcon} width={19} height={16} />
          <span>{t('infiniteScroll.endOfList')}</span>
        </div>
      }
    </InfiniteScrollComponent>
  )
}

InfiniteScroll.propTypes = {
  loaderClassName: PropTypes.string,
  endOfList: PropTypes.bool,
  children: PropTypes.node,
  hideLoader: PropTypes.bool,
}

export default InfiniteScroll
